export const ACCOUNT_DETAIL_SET_SELECTED_KEYS = "ACCOUNT_DETAIL_SET_SELECTED_KEYS";